import { observer } from 'mobx-react-lite';
import { Outlet, useNavigate } from 'react-router';
import { Page } from '../../../lib/components';
import { Box } from '@mui/material';
import { DatePickerBox } from '../../../lib/components/compound/pages/pageWithMenu/datePickerBox';
import { useEffect, useState } from 'react';
import { ReceiptStatusWidget } from '../widgets/statusWidget';
import { useStore } from '../../../hooks/useStore';
import { ReceiptInfo, ReceiptStatusEnum } from '@pxtra-client-lib-legacy/gen';
import { useTranslation } from 'react-i18next';
import Util from '../../../misc/util';
import { Button } from '../../../lib/components/atomic/button';

export const ReceiptsPagesPartial = observer(() => {
  const { receiptStore, companyStore } = useStore();
  const [info, setInfo] = useState<ReceiptInfo>();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [date, setDate] = useState<Date | undefined>(undefined);
  const [statusFilter, setStatusFilter] = useState<ReceiptStatusEnum | undefined>(undefined);

  useEffect(() => {
    const fn = async () => {
      if (!companyStore.company) return;

      const dateAfter = date ? Util.getFirstDayOfMonth(date) : undefined;
      const dateBefore = date ? Util.getLastDayOfMonth(date) : undefined;

      const info = await receiptStore.getInfo(undefined, undefined, dateAfter, dateBefore);
      setInfo(info.at(0));
    };
    fn();
  }, [date, companyStore.company, receiptStore.receiptList]);

  const handleStatusWidgetClick = (status: ReceiptStatusEnum) => {
    status === statusFilter ? setStatusFilter(undefined) : setStatusFilter(status);
  };

  return (
    <Page>
      <Box
        display={'flex'}
        gap={4}
        sx={{
          height: '100%',
          flexWrap: {
            md: 'unset',
            sm: 'wrap'
          }
        }}
      >
        <Box sx={{ height: '100%', flexBasis: '320px', flexGrow: 999 }}>
          <Outlet
            context={{
              date: [date, setDate],
              status: [statusFilter, setStatusFilter],
              context: 'receipts'
            }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexBasis: '320px',
            minWidth: '320px',
            flexGrow: 1,
            alignSelf: 'flex-start',
            flexDirection: 'column',
            gap: '24px'
          }}
        >
          <DatePickerBox date={date} onChange={setDate} openTo="month" resetButton />
          <ReceiptStatusWidget
            orientation="column"
            submitted={{
              count: info?.submitted_count,
              onClick: () => handleStatusWidgetClick('SUBMITTED')
            }}
            approved={{
              count: info?.approved_count,
              onClick: () => handleStatusWidgetClick('APPROVED')
            }}
            billed={{
              count: info?.billed_count,
              onClick: () => handleStatusWidgetClick('BILLED')
            }}
            rejected={{
              count: info?.rejected_count,
              onClick: () => handleStatusWidgetClick('REJECTED')
            }}
            selectedItem={statusFilter}
          />
          {!(location.pathname === '/receipts') && (
            <Button onClick={() => navigate('/receipts')}>{t('receipts:BACK_TO_OVERVIEW')}</Button>
          )}
        </Box>
      </Box>
    </Page>
  );
});
